/* eslint-disable max-len */
import { FC } from 'react';

import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const PlusSubscriptionPlusIcon: FC<Props> = ({ className }) => (
  <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18.5714C14.7339 18.5714 18.5714 14.7339 18.5714 10C18.5714 5.26613 14.7339 1.42857 10 1.42857C5.26613 1.42857 1.42857 5.26613 1.42857 10C1.42857 14.7339 5.26613 18.5714 10 18.5714ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="#272756"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2152 5.00073C10.6096 5.00073 10.9294 5.32053 10.9294 5.71502L10.9294 14.2864C10.9294 14.6809 10.6096 15.0007 10.2152 15.0007C9.82067 15.0007 9.50087 14.6809 9.50087 14.2864L9.50087 5.71502C9.50087 5.32053 9.82067 5.00073 10.2152 5.00073Z"
      fill="#272756"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0006 10.2152C15.0006 10.6096 14.6808 10.9294 14.2863 10.9294L5.7149 10.9294C5.32041 10.9294 5.00061 10.6096 5.00061 10.2152C5.00061 9.82067 5.32041 9.50087 5.7149 9.50087L14.2863 9.50087C14.6808 9.50087 15.0006 9.82067 15.0006 10.2152Z"
      fill="#272756"
    />
  </svg>
);
